import { AccordionSummary } from '@material-ui/core';
import styled from 'styled-components';

import { apx, px } from '../../../../../../../../../contrib/ui';

export const AccordionSummaryStyled = styled(AccordionSummary)`
  padding: ${px(5)};
  padding-left: ${px(20)};
  padding-right: ${px(20)};

  @media (--m-d-viewport) {
    padding: ${px(10)};
    padding-top: ${px(20)};
  }

  & > div:first-child {
    margin: 0;
  }
  .name {
    color: var(--dark);
    font-family: 'DINNextLTPro-Heavy';
    font-size: ${apx(22)};
    text-transform: uppercase;
  }
  .attr {
    color: var(--dark);
    font-family: 'DINNextLTPro-Heavy';
    font-size: ${apx(16)};
    text-transform: uppercase;
    display: flex;
    align-items: center;
  }
  .gender {
    width: ${px(80)};
    color: var(--dark);
    font-family: 'DINNextLTPro-Heavy';
    font-size: ${apx(16)};
    text-transform: uppercase;
    display: flex;
    align-items: center;
  }
`;
